import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import { userAPI } from './services/xcover/endpoints/user';
import { customerAPI } from './services/xcover/endpoints/customer';
import { claimBookingsAPI } from './services/xcover/endpoints/claimBookings';
import { claimsAPI } from './services/xcover/endpoints/claims';
import { xcoverAPI } from './services/xcover';
import { xcmsAPI } from './services/xcms';
// eslint-disable-next-line import/no-cycle
import { customerReducer } from './slices/customer';
import { rtkQueryErrorLogger } from './middlewares/ApiErrorLogger';

const makeStore = () =>
  configureStore({
    reducer: {
      [xcoverAPI.reducerPath]: xcoverAPI.reducer,
      [xcmsAPI.reducerPath]: xcmsAPI.reducer,
      customer: customerReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat(xcoverAPI.middleware)
        .concat(xcmsAPI.middleware)
        .concat(rtkQueryErrorLogger),
  });

export default makeStore;

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const wrapper = createWrapper<AppStore>(makeStore, { debug: false });

export const { useCheckCustomerMutation, useGetCustomerByIDQuery } = customerAPI;
export const { useLoginUserMutation } = userAPI;
export const {
  useGetCustomerClaimBookingsQuery,
  useLazyGetCustomerClaimBookingQuery,
  useGetCustomerClaimBookingQuery,
} = claimBookingsAPI;
export const {
  useGetCustomerClaimsListQuery,
  useGetClaimDetailsViewQuery,
  useGetFeedbackQuery,
  useSubmitFeedbackMutation,
} = claimsAPI;
